export class InfoText {
    static readonly OrgTypeInfo =
        'Changes to the company/organization type of an existing organization must be made directly in CiviCRM.';
}
